<div class="add-property-form-wrapper">
  <tidy-row>
    <form [formGroup]="addPropertyForm">
      <tidy-auto-complete
        [label]="'Address'"
        formControlName="address"
        [options]="addressSuggestions"
        [icon]="'assets/svg/home.svg'"
        [form]="addPropertyForm.controls.address"
        [errorMessage]="'Please enter a valid address'"
        (keyup)="onAddressSearch()"
        (action)="selectAddressSuggestion($event)" />
    </form>
  </tidy-row>

  @if (addressConfirmed) {
    <tidy-row>
      <div class="detected-location">
        <span class="material-icons">place</span>
        <span class="location-text">{{ detectedLocationSummary }}</span>
        <span class="material-icons check">check_circle</span>
      </div>
    </tidy-row>
    <tidy-row>
      <form [formGroup]="addPropertyForm">
        <tidy-input
          formControlName="address2"
          [form]="addPropertyForm.controls.address2"
          [label]="'Unit / Apt (optional)'"
          [icon]="'assets/img/door.svg'" />
      </form>
    </tidy-row>
    <tidy-row>
      <form [formGroup]="addPropertyForm">
        <tidy-input
          formControlName="addressNickname"
          [form]="addPropertyForm.controls.addressNickname"
          [label]="'Nickname (optional)'"
          [icon]="'assets/svg/information-circle.svg'" />
      </form>
    </tidy-row>
  }

  @if (addPropertyError) {
    <div class="form-error">{{ addPropertyError }}</div>
  }

  <tidy-row>
    <tidy-button
      [text]="'Add Property'"
      class="primary full-width"
      [disabled]="!addressConfirmed || isAddingProperty"
      [action]="submitAddProperty" />
  </tidy-row>

  @if (data?.showImportButton) {
    <tidy-row>
      <tidy-button
        [text]="'Import from Integration'"
        [image]="'assets/svg/sync-outline.svg'"
        class="secondary full-width"
        [action]="goToIntegration" />
    </tidy-row>
  }

  @if (isRentalClient) {
    <div class="go-live-section">
      <tidy-text [header]="'Go Live in 90 Minutes'" />
      <tidy-text [body]="'Every account includes a dedicated human Account Manager to get you set up.'" />
      <div class="go-live-steps">
        @for (step of goLiveSteps; let i = $index; track step.step) {
          <div class="go-live-step" [class.step-dimmed]="i > activeStepIndex">
            <div class="step-badge" [class.step-active]="i <= activeStepIndex">
              <span>{{ step.step }}</span>
            </div>
            <tidy-text [body]="'<b>' + step.title + '</b>'" />
            <tidy-text [body]="step.desc" />
          </div>
        }
      </div>
    </div>
  }
</div>
